module.exports = __webpack_public_path__ + "img/banner-2-1.4d214202.png";